import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">Last Updated: February 11, 2025</p>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">1. Introduction</h2>
        <p>Welcome to Eeezo Connect. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and services.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">2. Information We Collect</h2>
        <ul className="list-disc pl-5">
          <li>Personal information such as name, email, and contact details.</li>
          <li>Usage data including interactions with our platform.</li>
          <li>Cookies and tracking technologies to enhance user experience.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">3. How We Use Your Information</h2>
        <p>We use your data to:</p>
        <ul className="list-disc pl-5">
          <li>Provide and maintain our services.</li>
          <li>Improve user experience and develop new features.</li>
          <li>Communicate with you regarding updates and support.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">4. Data Sharing and Security</h2>
        <p>We do not sell your personal information. We may share data with trusted third parties to enhance our services. Your data is secured using industry-standard encryption and protocols.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">5. Your Rights</h2>
        <p>You have the right to access, modify, or delete your personal data. Contact us at <a href="mailto:support@eeezo.com" className="text-blue-500">support@eeezo.com</a> for requests.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-xl font-semibold">6. Changes to This Policy</h2>
        <p>We may update this Privacy Policy periodically. Any changes will be posted on this page.</p>
      </section>
      
      <p className="mt-6">For more information, visit our <a href="/" className="text-blue-500">homepage</a>.</p>
    </div>
  );
};

export default PrivacyPolicy;

